import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import {
	LazyTeamCalendarSiteSettingsPage,
	ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE,
} from '@confluence/team-calendar';

export const AdminTeamCalendarsRoute: {
	(): React.JSX.Element | null;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element | null => {
	const { edition } = useSessionData();

	if (edition !== ConfluenceEdition.PREMIUM) {
		return null;
	}

	return <LazyTeamCalendarSiteSettingsPage />;
};

AdminTeamCalendarsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
